import {
  Component,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { OnyxEvent } from '../../models/event';
import { TranslateService } from '@ngx-translate/core';
import { ErrorHandlerService } from '../../../shared/utils/error-handler.service';
import { AdjustmentUtils } from '../../utils/adjustment-utils';
import { Payment } from '../../models/payment';
import { PaymentModifier } from '../../models/payment-modifier';
import { PaymentStore } from '../../service/payment.store';
import { LogService } from '../../../shared/log/log.service';

@Component({
  selector: 'pioneer-payment-modifier-display',
  templateUrl: './payment-modifier-display.component.html'
})
export class PaymentModifierDisplayComponent implements OnInit {

  @HostBinding('class') defaultClasses = 'col form-container due-amount';
  @HostBinding('class.has-adjust') hasModifiersCssClass = false;

  @Input()
  @HostBinding('class.status-rejected')
  strikeThroughPaymentLines = false;

  private onyxEvent: OnyxEvent;

  constructor(
    private translateService: TranslateService,
    private errorHandlerService: ErrorHandlerService,
    private logService: LogService,
    private paymentStore: PaymentStore
  ) {}

  @Input()
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  ngOnInit() {
    this.areThereAnyModifiers().subscribe( modifierExists => {
      this.logService.debug('ngOnInit - areThereAnyModifiers: hasModifiersCssClass: ' + modifierExists);
      this.hasModifiersCssClass = modifierExists;
    });

    if (!this.onyxEvent) {
      this.errorHandlerService.throw(
        'Input property onyxEvent is null in AddPaymentComponent',
        this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
          property: 'onyxEvent',
          className: 'PaymentEquationComponent'
        })
      );
    }
  }

  get latestPayment(): Observable<Payment> {
    return this.paymentStore.getLatestPayment();
  }

  get calculatedPayment(): Observable<number> {
    return this.latestPayment.map(payment => {
      this.logService.debug('calculatedPayment: payment' + payment);
      if (payment.commissionAmount) {
        return payment.commissionAmount;
      } else {
        return 0;
      }
    });
  }

  get modifiers(): Observable<PaymentModifier[]> {
    return this.latestPayment.share().map(payment => {
      this.logService.debug('modifiers: payment' + payment);
      if (payment.eventPaymentModifiers) {
        this.logService.debug('modifiers: eventPaymentModifiers: ' + payment.eventPaymentModifiers);
        return payment.eventPaymentModifiers;
      } else {
        return [];
      }
    });
  }

  get totalModifiersAmount(): Observable<number> {
    return this.modifiers.map(modifierArray => {
      return modifierArray.map(modifier => modifier.adjustmentAmount)
        .filter(amt => amt !== null)
        .reduce((prev: number, current: number) => !!current ? prev + current : prev, 0);
    });
  }

  get totalCommission(): Observable<number> {
    return this.calculatedPayment.flatMap( (paymentAmt: number) => {
      return this.totalModifiersAmount.map( (modifierAmount: number) => {
        return paymentAmt - modifierAmount;
      });
    });
  }

  areThereAnyModifiers(): Observable<boolean> {
    return this.modifiers.map(modifierArray => {

      let hasModifiers = false;

      if (modifierArray && modifierArray.length > 0) {
        hasModifiers = true;
      }

      this.logService.debug('areThereAnyModifiers: modifierArray: ' + modifierArray);
      this.logService.debug('areThereAnyModifiers: hasModifiers: ' + hasModifiers);

      return hasModifiers;
    });
  }

  getModifierCssClass(adjustment: PaymentModifier): string {
    if (AdjustmentUtils.isAdjustmentTypePositive(adjustment.adjustmentType)) {
      return 'adjustment up';
    } else {
      return 'adjustment down';
    }
  }

  getModifierAmountCssClass(adjustment: PaymentModifier): string {
    if (AdjustmentUtils.isAdjustmentTypePositive(adjustment.adjustmentType)) {
      return 'currency text-success';
    } else {
      return 'currency text-warning';
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/payment-modifier-display-calculation/payment-modifier-display.component.ts